import { render, staticRenderFns } from "./SaleAITaskSection.vue?vue&type=template&id=5d4b2354"
import script from "./SaleAITaskSection.vue?vue&type=script&lang=js"
export * from "./SaleAITaskSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports